import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderCloneAtom = createMutationAtomFactory(
  'trade.salesOrderClone',
  (params: { id: string }) => ({
    tradeSalesOrderClone: {
      __args: {
        id: params.id,
      },
      id: true,
      documentNumber: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
